module.exports = __webpack_public_path__ + "3e34f8e0969831afe6ae7fe27899aa4e.pdf";